/**
 * Constants for the Communities feature.
 */

export const READER_NAV_TABS = [
  { key: 'home', label: 'Home' },
  { key: 'discussions', label: 'Discussions' },
  { key: 'books', label: 'Books' },
  { key: 'events', label: 'Events' },
  { key: 'members', label: 'Members' },
  { key: 'about', label: 'About' },
];

export const WRITER_NAV_TABS = [
  { key: 'home', label: 'Home' },
  { key: 'discussions', label: 'Discussions' },
  { key: 'writing', label: 'Writing' },
  { key: 'prompts', label: 'Prompts' },
  { key: 'critiques', label: 'Critiques' },
  { key: 'events', label: 'Events' },
  { key: 'members', label: 'Members' },
  { key: 'about', label: 'About' },
];

export const POST_TYPES = [
  { value: 'discussion', label: 'Discussion' },
  { value: 'question', label: 'Question' },
  { value: 'recommendation', label: 'Recommendation' },
  { value: 'review', label: 'Review' },
  { value: 'poll', label: 'Poll' },
  { value: 'reading_update', label: 'Reading Update' },
  { value: 'book_discussion', label: 'Book Discussion' },
  { value: 'announcement', label: 'Announcement' },
];

export const WRITER_POST_TYPES = [
  { value: 'writing_prompt', label: 'Writing Prompt' },
  { value: 'share_writing', label: 'Share Your Work' },
  { value: 'feedback_request', label: 'Feedback Request' },
  { value: 'writing_update', label: 'Writing Update' },
  ...POST_TYPES,
];

export const POST_TYPE_LABELS = Object.fromEntries(
  [...POST_TYPES, ...WRITER_POST_TYPES].map(({ value, label }) => [value, label])
);

export const VISIBILITY_META = {
  public: { label: 'Public', hint: 'Anyone can join' },
  private: { label: 'Private', hint: 'Requires approval to join' },
  restricted: { label: 'Invite-only', hint: 'Membership by invitation' },
};

export const ROLE_LABELS = {
  admin: 'Admin',
  moderator: 'Moderator',
  member: 'Member',
};

export const EMPTY_STATE_MESSAGES = {
  myCommunities: {
    heading: 'Your people are out there.',
    subheading: 'Find a community that shares your love for stories.',
    cta: 'Explore Communities',
  },
  discussions: {
    heading: "It's quiet in here… start the conversation.",
    subheading: 'Be the first to post in this community.',
    cta: 'Start Discussion',
  },
  events: {
    heading: 'No book club meetings yet.',
    subheading: 'Create the first event for this community.',
    cta: 'Create Event',
  },
  members: {
    heading: 'No members yet.',
    subheading: 'This community is just getting started.',
  },
  notifications: {
    heading: "You're all caught up.",
    subheading: 'Nothing new since last time.',
  },
  search: {
    heading: 'No communities found.',
    subheading: 'Try a different search term or category.',
    cta: 'Clear Search',
  },
};
